import { Button, Group, StackedContainer, Text } from '@melio/penny';
import { useAnalytics } from '@melio/platform-analytics';
import { useMelioIntl } from '@melio/platform-i18n';
import { useNavigate } from 'react-router-dom';

export const VendorEBillSubscriptionSection = ({ vendorId }: { vendorId: string }) => {
  const { formatMessage } = useMelioIntl();
  const navigate = useNavigate();
  const { track } = useAnalytics();

  const onEBillSubscription = () => {
    track('PaymentScheduledSucceeded', 'Click', { Cta: 'subscribe' });
    navigate(`../../vendors/${vendorId}/ebills-subscription`, { state: { returnUrl: '..' } });
  };

  return (
    <StackedContainer stacksToDisplay={0} paddingX="m" paddingY="m" data-testid="vendor-ebill-subscription-section">
      <Group variant="vertical">
        <Text textStyle="body2Semi">
          {formatMessage(
            'activities.paymentScheduled.screens.paymentScheduled.description.singlePayment.eBills.subscription.title'
          )}
        </Text>
        <Text textStyle="body4" color="neutral.darker">
          {formatMessage(
            'activities.paymentScheduled.screens.paymentScheduled.description.singlePayment.eBills.subscription.description'
          )}
        </Text>
        <Button
          variant="primary"
          label={formatMessage(
            'activities.paymentScheduled.screens.paymentScheduled.description.singlePayment.eBills.subscription.cta'
          )}
          size="large"
          onClick={onEBillSubscription}
          data-testid="vendor-ebill-subscription-button"
        />
      </Group>
    </StackedContainer>
  );
};
